import { Join, Space } from '@gousto-internal/citrus-react'
import React from 'react'
import { OrderTabItem } from './OrderTabItem'
import type { OrderTab } from './OrderTabs.types'

type OrderTabsProps = {
  orderTabs: OrderTab[]
  activeIndex: number
  onChange: (index: number) => void
}
export type { OrderTab } from './OrderTabs.types'

export function OrderTabs({ orderTabs, activeIndex, onChange }: OrderTabsProps) {
  return (
    <Join with={<Space size={4} />}>
      {orderTabs.map((tab, index) => (
        <OrderTabItem
          key={tab.order_id}
          index={index}
          tab={{
            date_title: tab.date_title,
            discount: tab.discount,
            icon: tab.icon,
            isActive: index === activeIndex,
          }}
          onActivate={onChange}
        />
      ))}
    </Join>
  )
}
